import React, { useEffect } from 'react'
import { FaRegFolderOpen } from 'react-icons/fa' // Import empty state icon
import { GET_CABS_BY_FLEET_OWNER } from '../../Services/cabapi/fleetggl'
import { useQuery } from '@apollo/client'
import moment from 'moment'
import { SkyButton } from '../../Components/Buttons'
import { useNavigate } from 'react-router-dom'
import { getDecryptedSessionStorageVariable } from '../../utils/encryptStorage'

const ManageCabs = () => {
  const navigate = useNavigate()
  const fleetId = getDecryptedSessionStorageVariable('fleetId')
  const { loading, error, data, refetch } = useQuery(GET_CABS_BY_FLEET_OWNER, {
    variables: {
      fleetOwnerId: fleetId,
    },
  })

  useEffect(() => {
    refetch()
  }, [])

  if (loading) {
    return <div>Loading...</div>
  }
  if (error) {
    return <div>Error: {error.message}</div>
  }

  return (
    <div>
      <div className="w-full  h-full bg-white p-4 shadow rounded-md text-start">
        <div className="sticky top-0">
          <div className="text-stone-500 text-xl font-bold mb-4">
            Manage Cab
          </div>
          <div className="my-3 flex justify-end">
            <SkyButton label={`Add Cab`} onClick={() => navigate('add-cab')} />
          </div>
        </div>
        <div className="mt-4 w-full overflow-x-auto h-[70vh]">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-collapse border border-gray-300">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
              <tr className="sticky top-0">
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Car Owner Name
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Car Number
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Registration Date
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Registration Expiry Date
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Insurance Expiry Date
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  PUC Expiry Date
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Color
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Variant
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Menu
                </th>
                <th scope="col" className="px-6 py-3 border border-gray-300">
                  Verification Status
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.getCabByFleetOwner?.length === 0 ? (
                <tr className="">
                  <td
                    colSpan="9"
                    className="text-center py-10 text-gray-500 flex items-center justify-center"
                  >
                    <FaRegFolderOpen size={40} />
                    <span className="ml-4 text-xl">No Data Available</span>
                  </td>
                </tr>
              ) : (
                data?.getCabByFleetOwner?.map((items, index) => (
                  <tr key={index} className="bg-white border-b">
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.carOwnerName}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.carNo}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {moment(items?.registrationDate).format('lll')}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {moment(items?.registrationExpiryDate).format(
                        'DD-MMMM-YYYY'
                      )}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {moment(items?.insuranceExpiryDate).format(
                        'DD-MMMM-YYYY'
                      )}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {moment(items?.pucExpiryDate).format('DD-MMMM-YYYY')}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.color}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.variant}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      <SkyButton
                        label={'Edit'}
                        onClick={() => {
                          navigate('/manage-cab/edit-cab', {
                            state: items,
                          })
                        }}
                      />
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.isVerified ? 'Verified' : 'Un-Verified'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ManageCabs
